@if (sanitizedUrl()) {
  <iframe
    [src]="sanitizedUrl()"
    title="Absetzungsschreiben"
    style="flex: 1; border: unset"
  ></iframe>
}
